import { React, useEffect, useState, useRef } from "react";
import "../../Modules/Tickets/Ticketslist.css";
import rectangle from "../../Assets/svg/rectangle.svg";
import lar from "../../Assets/svg/lar.svg";
import clock from "../../Assets/svg/clock.svg";
import set from "../../Assets/svg/set.svg";
import green from "../../Assets/svg/green.svg";
import { Link } from "react-router-dom";
import backarrow from "../../Assets/svg/backarrow.svg";
import nan from "../../Assets/png/nan.png";
import sak from "../../Assets/png/sak.png";
import excel from "../../Assets/png/excel.png";
import fileType from "../../Assets/png/file.png";
import docTpe from "../../Assets/png/docs.png";
import imageType from "../../Assets/png/docs.png";
import download from "../../Assets/svg/download.svg";
import note from "../../Assets/png/note.png";
import play from "../../Assets/svg/play.svg";
import pause from "../../Assets/svg/pause.svg";
import time from "../../Assets/svg/time.svg";
import close from "../../Assets/svg/close.svg";
import arrows from "../../Assets/svg/arrows.svg";
import calendar from "../../Assets/svg/calendar.svg";
import moment from "moment";
import UserImg from "../../Assets/png/user-icon.png";
import { ReactComponent as ModalCloseIcon } from "../../Assets/svg/close-modal.svg";
import { Container, Row, Col } from "react-bootstrap";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { ReactComponent as CalendarIcon } from "../../Assets/svg/calendar.svg";
import completeIcon from "../../Assets/svg/completed-status.svg";
import createdIcon from "../../Assets/svg/created-status.svg";
import greyIcon from "../../Assets/svg/grey.svg";
import yellowIcon from "../../Assets/svg/yellow.svg";
import subTicketIcon from "../../Assets/svg/sub-ticket-icon.svg";
import { useGlobal } from "../../GlobalContext.js";
import StatusUpdateModal from "./modal/status-update.js";
import { getAttachmentIcon } from "../common/attachment-icon";
import HtmlContent from "../common/html-content";
import { apiCall } from "../../services/api-service.js";
import { getEnabledFieldApi } from "./Ticketapi.js";
const Ticketlistview = ({ tableData, refreshList }) => {
  const { rolePermissionList } = useGlobal();
  const [additionalPermissionList, setAdditionalPermissionList] = useState([]);
  const [ticketDetail, setTicketDetail] = useState({});
  const [attachmentList, setAttachmentList] = useState([]);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [previewImageName, setPreviewImageName] = useState("");
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [workflowList, setWorkflowList] = useState([]);
  const [commentsList, setCommentsList] = useState([]);
  const [totalCommentCount, setTotalCommentCount] = useState(0);

  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [loading, setLoading] = useState(false);
  const [expectedDate, setExpectedDate] = useState("");
  const [enabledFields, setEnabledFields] = useState([]);
  const [fieldLabels, setFieldLabels] = useState({});

  const getEnabledField = async () => {
    try {
      const response = await getEnabledFieldApi();
      if (response?.status === 200 && response.data?.success === true) {
        setEnabledFields(response.data.enabled_fields || []);
        setFieldLabels(response.data.application_labels || response.data.labels || {});
      }
    } catch (err) {
      console.error("Error fetching enabled fields:", err);
    }
  };

  useEffect(() => {
    getEnabledField();
  }, []);

  const isFieldEnabled = (fieldName) => {
    if (!enabledFields || enabledFields.length === 0) return true;
    return enabledFields.includes(fieldName);
  };

  const getFieldLabel = (fieldKey, defaultLabel) => {
    let custom = fieldLabels?.[fieldKey];
    if ((!custom || typeof custom !== "string" || custom.trim() === "") && (fieldKey === "Customer" || fieldKey === "Client Name")) {
      custom = fieldLabels?.["Customer"] || fieldLabels?.["Client Name"];
    }
    if (custom && typeof custom === "string" && custom.trim() !== "") {
      return custom.trim();
    }
    return defaultLabel;
  };
  const [closingDate, setClosingDate] = useState("");
  const [workDuration, setWorkDuration] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [rating, setRating] = useState(0);
  const [ticketId, setTicketId] = useState("");
  const [validations, setValidations] = useState({
    expected_date: "",
    description: "",
    work_duration: "",
    closing_date: "",
  });
  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(null);

  function checkPermission(permission) {
    return rolePermissionList.findIndex((element) => element["name"] === "Ticket" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  function checkAdditionalPermission(menuName) {
    if (!checkPermission("additional_permission")) {
      return false;
    }
    return additionalPermissionList.findIndex((element) => element["name"] === menuName && element["permission"] === true) > -1 ? true : false;
  }
  const [ticketsList, setTicketsList] = useState([]);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [hasMoreTickets, setHasMoreTickets] = useState(true);
  const ticketListRef = useRef(null);

  // useEffect(() => {
  //   if (tableData.length > 0) {
  //     setTicketId(tableData[0].id);
  //   }
  // }, []);
  // useEffect(() => {
  //   const index = rolePermissionList.findIndex((element) => element["name"] === "Ticket");
  //   if (index > -1) {
  //     setAdditionalPermissionList(rolePermissionList[index].additional_permissions_list);
  //   }
  //   setCommentsList([]);
  //   getTicketData();
  //   getAttachmentList();
  //   getCommentsList("");
  //   getWorkflowList();
  // }, [ticketId]);

  // useEffect(() => {
  //   if (tableData.length > 0) {
  //     setTicketsList(tableData);
  //     setTicketId(tableData[0].id);
  //   }
  // }, [tableData]);

  const normalizeEscapedText = (value) => {
    return (value ?? "")
      .replace(/\\r\\n/g, "\n")
      .replace(/\\r/g, "\n")
      .replace(/\\n/g, "\n")
      .replace(/\t/g, "    ")
      .trim();
  };

  const getPriorityColor = (p) => {
    switch (p) {
      case "High": return "#F44336";
      case "Medium": return "#FFC107";
      case "Low": return "#4CAF50";
      default: return "#E0E0E0";
    }
  };

  // Sync tickets list and select the first ticket by default when in Card view
  useEffect(() => {
    if (tableData.length > 0) {
      setTicketsList(tableData);
      setTicketId((prevId) => {
        const exists = tableData.some((t) => t.id === prevId);
        return exists ? prevId : tableData[0].id;
      });
    } else {
      setTicketId("");
      setTicketsList([]);
    }
  }, [tableData]);

  // Fetch data when ticketId actually changes
  useEffect(() => {
    if (!ticketId) return;

    const index = rolePermissionList.findIndex((element) => element.name === "Ticket");
    if (index > -1) {
      setAdditionalPermissionList(rolePermissionList[index].additional_permissions_list);
    }

    setCommentsList([]);
    getTicketData();
    getAttachmentList();
    getCommentsList("");
    getWorkflowList();
  }, [ticketId]);

  // Refs to avoid stale closures in scroll handler
  const isLoadingMoreRef = useRef(false);
  const hasMoreTicketsRef = useRef(true);
  const ticketsLengthRef = useRef(0);

  useEffect(() => {
    isLoadingMoreRef.current = isLoadingMore;
  }, [isLoadingMore]);
  useEffect(() => {
    hasMoreTicketsRef.current = hasMoreTickets;
  }, [hasMoreTickets]);
  useEffect(() => {
    ticketsLengthRef.current = ticketsList.length;
  }, [ticketsList.length]);

  // Add scroll event listener
  useEffect(() => {
    const ticketListElement = ticketListRef.current;
    if (!ticketListElement) return;

    const handleScroll = () => {
      if (ticketListElement.scrollHeight - ticketListElement.scrollTop <= ticketListElement.clientHeight + 150) {
        if (!isLoadingMoreRef.current && hasMoreTicketsRef.current) {
          loadMoreTickets();
        }
      }
    };

    ticketListElement.addEventListener("scroll", handleScroll);
    return () => ticketListElement.removeEventListener("scroll", handleScroll);
  }, []);

  // Load more tickets function
  const loadMoreTickets = async () => {
    if (isLoadingMoreRef.current || !hasMoreTicketsRef.current) {
      return;
    }

    setIsLoadingMore(true);

    try {
      const response = await apiCall("get", "ticket", null, {
        params: {
          limit: 10,
          skip: ticketsLengthRef.current,
        },
      });

      if (response.data.success === true) {
        if (response.data.tickets && response.data.tickets.length > 0) {
          setTicketsList((prev) => [...prev, ...response.data.tickets]);

          if (response.data.tickets.length < 10) {
            setHasMoreTickets(false);
          }
        } else {
          setHasMoreTickets(false);
        }
      }
    } catch (error) {
      console.error("Error loading more tickets:", error);
      setHasMoreTickets(false);
    } finally {
      setIsLoadingMore(false);
    }
  };

  const getTicketData = async () => {
    const response = await apiCall("get", `ticket/view/${ticketId}`);
    if (response?.status === 200 && response.data?.success === true) {
      setTicketDetail({ ...response.data.ticket, fetchedAt: new Date() });
    }
  };

  const getAttachmentList = async () => {
    const response = await apiCall("get", `ticket/attachment/${ticketId}`);
    if (response?.status === 200 && response.data?.success === true) {
      setAttachmentList(response.data.attachments ?? []);
    }
  };
  const saveAttachment = async (base64, name) => {
    setLoading(true);
    try {
      const data = {
        attachment: base64,
        attachment_name: name,
      };
      const response = await apiCall("put", `ticket/add_attachment/${ticketId}`, data);
      if (response?.status === 200 && response.data?.success === true) {
        getAttachmentList();
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };
  const removeAttachment = async (attachmentId) => {
    setLoading(true);
    try {
      const data = {};
      const response = await apiCall("put", `ticket/remove_attachment/${attachmentId}`, data);
      if (response?.status === 200 && response.data?.success === true) {
        setAlertIndex(null);
        getAttachmentList();
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };
  const getCommentsList = async (seeMore) => {
    const response = await apiCall("get", `ticket/comment/${ticketId}`, null, {
      params:
        seeMore === ""
          ? {}
          : {
              limit: 10,
              skip: commentsList.length,
            },
    });
    if (response?.status === 200 && response.data?.success === true) {
      setTotalCommentCount(response.data.total_rec ?? 0);
      if (seeMore !== "" && (response.data.comments ?? []).length > 0) {
        setCommentsList((prev) => [...prev, ...response.data.comments]);
      } else {
        setCommentsList(response.data.comments ?? []);
      }
    }
  };
  const saveComment = async () => {
    setLoading(true);
    try {
      const data = {
        comment: descriptionInputValue,
      };
      const response = await apiCall("put", `ticket/add_comment/${ticketId}`, data);
      if (response?.status === 200 && response.data?.success === true) {
        closeCommentModal();
        getCommentsList("");
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };
  const getWorkflowList = async () => {
    const response = await apiCall("get", `ticket/workflow/${ticketId}`);
    if (response?.status === 200 && response.data?.success === true) {
      setWorkflowList(response.data.histories ?? []);
    }
  };
  const statusUpdate = async (status) => {
    const data = {
      status: status,
    };
    if (status === "Hold") {
      data["expected_date"] = expectedDate;
      data["description"] = descriptionInputValue;
    }
    if (status === "Closed") {
      data["work_duration"] = workDuration;
      data["closing_date"] = closingDate;
      data["description"] = descriptionInputValue;
    }
    if (status === "Completed") {
      data["rating"] = rating;
      data["description"] = descriptionInputValue;
    }
    setTicketDetail((prev) => ({ ...prev, status: status }));
    const response = await apiCall("put", `ticket/status_update/${ticketId}`, data);
    if (response?.status === 200 && response.data?.success === true) {
      closeStatusUpdateModal();
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      getTicketData();
      getWorkflowList(ticketId);
      refreshList?.();
      return;
    }
    if (response?.status === 400 && response.data?.error) {
      const validationTemp = {
        expected_date: "",
        description: "",
        work_duration: "",
        closing_date: "",
      };
      Object.entries(response.data.error).forEach(([key, value]) => {
        validationTemp[key] = value.length === 0 ? "" : value[0];
      });
      setValidations(validationTemp);
    }
  };
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  const isImageAttachment = (attachment) => {
    const mimeType = (attachment?.mime_type ?? attachment?.content_type ?? attachment?.type ?? "").toString().toLowerCase();

    if (mimeType.startsWith("image/")) {
      return true;
    }

    const fileSource = (attachment?.name ?? attachment?.url ?? "").toString().toLowerCase().split("?")[0].split("#")[0];

    const extension = fileSource.includes(".") ? fileSource.substring(fileSource.lastIndexOf(".") + 1) : "";

    return ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(extension);
  };

  const openImagePreview = (attachment) => {
    if (!attachment?.url || !isImageAttachment(attachment)) {
      return;
    }

    setPreviewImageUrl(attachment.url);
    setPreviewImageName(attachment.name ?? "Attachment Image");
    setIsImagePreviewOpen(true);
  };

  const closeImagePreview = () => {
    setIsImagePreviewOpen(false);
    setPreviewImageUrl("");
    setPreviewImageName("");
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Created":
        return createdIcon;

      case "In Progress":
        return play;

      case "Hold":
        return pause;

      case "Closed":
        return close;
      case "Completed":
        return completeIcon;
      default:
        return play;
    }
  };
  const [isOpenComment, setIsOpenComment] = useState(false);
  const closeCommentModal = () => {
    setIsOpenComment(false);
    setDescriptionInputValue("");
  };

  const commentModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "688px",
      height: "313px",
      textAlign: "center",
      overflowY: "auto",
    },
  };
  const [isOpenHold, setIsOpenHold] = useState(false);
  const closeHoldModal = () => {
    setIsOpenHold(false);
    setExpectedDate(null);
    setDescriptionInputValue("");
  };
  const holdModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "688px",
      height: "425px",
      textAlign: "center",
      overflowY: "auto",
    },
  };
  const [isOpenClose, setIsOpenClose] = useState(false);
  const [isOpenStatusUpdate, setIsOpenStatusUpdate] = useState(false);
  const closeStatusUpdateModal = () => {
    setIsOpenHold(false);
    setIsOpenClose(false);
    setIsOpenStatusUpdate(false);
    setWorkDuration("");
    setClosingDate(null);
    setExpectedDate(null);
    setDescriptionInputValue("");
    setValidations((validation) => {
      const validationTemp = validation;
      Object.entries(validationTemp).forEach(([key, value]) => {
        console.log(`${key}: ${value}`);
        validationTemp[key] = "";
      });

      console.log(validationTemp);
      return validationTemp;
    });
  };
  const closeModalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "688px",
      height: "425px",
      textAlign: "center",
      overflowY: "auto",
    },
  };
  const [showPicker, setShowPicker] = useState(false);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDatePicker);
    };
  }, []);
  const alertDatePicRef = useRef(null);
  const [alertIndex, setAlertIndex] = useState(null);
  const handleCloseDatePicker = (event) => {
    if (alertDatePicRef.current && !alertDatePicRef.current.contains(event.target)) {
      setShowPicker(false);
    }
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertIndex(null); // Close the alert
    }
  };
  const handleDateChange = (date) => {
    console.log("handleDateChange.......", date);
    if (date !== undefined) {
      setExpectedDate(moment(date).format("YYYY-MM-DD"));
      setShowPicker(false);
    }
  };
  const handleClosingDateChange = (date) => {
    if (date !== undefined) {
      console.log(moment(date).format("YYYY-MM-DD"));
      setClosingDate(moment(date).format("YYYY-MM-DD"));
      setShowPicker(false);
    }
  };
  function formatDate(inputDate) {
    try {
      if (inputDate !== undefined) {
        /* // Parse the input date (MM/DD/YYYY format)
        const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());

        // Format the date
        return format(parsedDate, "EEEE, dd MMM yyyy"); */
        return moment(inputDate).format("dddd, DD MMM YYYY");
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }

  const handleChange = (event) => {
    const inputText = event.target.value;
    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
      console.log(event.key);
      if (lastKey === "Backspace") {
        setWorkDuration(inputText);
      } else {
        setWorkDuration(inputText.length === 2 ? inputText + ":" : inputText);
      }
    }
  };
  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file /* && file.type.startsWith("image/") */) {
      /* const reader = new FileReader();
        reader.onload = async () => {
          const base64String = await reader.result; // this will be the byte code (base64String)
          console.log("Base64 String:", base64String.toString());
          saveAttachment(await reader.result);
        };
        reader.readAsDataURL(file);  */
      const response = await convertToBase64(file);
      saveAttachment(response, file.name);
    } else {
      alert("Please select a valid image file.");
    }
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const alertRef = useRef(null);
  function onSuccessStatus() {
    setShowStatusUpdate(false);
    setSnackbarMessage("Status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getTicketData();
    getWorkflowList(ticketId);
  }
  return (
    <>
      {showStatusUpdate && (
        <StatusUpdateModal
          ticketDetail={ticketDetail}
          statusUpdate={updateStatus}
          success={onSuccessStatus}
          onHide={() => {
            setShowStatusUpdate(false);
          }}
        />
      )}
      <Row className="mt-2">
        <Col sm={12} lg={4}>
          <div
            ref={ticketListRef}
            style={{
              height: "calc(95vh - 130px)",
              borderRadius: "16px",
              marginLeft: "16px",
              gap: "12px",
              backgroundColor: "#FFFFFF",
              overflowY: "scroll",
              scrollBehavior: "smooth",
              whiteSpace: "nowrap",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {ticketsList.map((item, index) => (
              <div
                key={item.id}
                className="ticket-card-listing"
                onClick={() => {
                  setTicketId(item.id);
                }}
                style={{
                  cursor: "pointer",
                  padding: "10px",
                  paddingBottom: "6px",
                  paddingTop: "6px",
                  background: ticketId === item.id ? "#E5E5E5" : "#FFFFFF",
                  borderBottom: "0.6px solid #E5E5E5",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "11px",
                      color: "#212129",
                    }}
                  >
                    {item.code} {"-"} {item.title}{" "}
                    {item.is_sub === true && (
                      <img
                        src={subTicketIcon}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginLeft: "8px",
                          marginTop: "-4px",
                        }}
                      />
                    )}{" "}
                  </span>
                  <div
                    style={{
                      width: "24px",
                      height: "23.38px",
                      marginLeft: "57px",
                    }}
                  >
                    {/*  <img src={set} style={{width:'2.4px',height:'10.52px'}}/> */}
                  </div>
                </div>
                <div
                  style={{
                    fontFamily: "Satoshi",
                    fontWeight: "400",
                    fontSize: "11px",
                    lineHeight: "16.2px",
                    color: "#8790A1",
                    paddingBottom: "2px",
                  }}
                >
                  Due {item.date}{" "}
                  <span
                    style={{
                      paddingLeft: "4px",
                      fontFamily: "Satoshi",
                      fontWeight: "600",
                      fontSize: "11px",
                      lineHeight: "16.2px",
                      color: "#6929E2",
                    }}
                  >
                    {item.status}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        height: "20px",
                        borderRadius: "8px",
                        padding: "6px 10px 6px 10px",
                        backgroundColor: "#F6F7F8",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginRight: "16px",
                      }}
                    >
                      <img src={clock} style={{ width: "12px", height: "12px", margin: "0" }} />
                      <span
                        style={{
                          paddingLeft: "6px",
                          fontFamily: "Satoshi",
                          fontWeight: "600",
                          fontSize: "10px",
                          lineHeight: "14.85px",
                          color: "#212129",
                          margin: "0",
                        }}
                      >
                        {item.est ?? "00:00"} hrs
                      </span>
                    </div>
                    {item.priority!=null && item.priority!=""&&(<div
                      style={{
                        height: "20px",
                        borderRadius: "4px",
                        padding: "6px 10px 6px 10px",
                        gap: "10px",
                        backgroundColor:
                          item.priority === "High"
                            ? "#FF4444"
                            : item.priority === "Medium"
                            ? "#E8A700"
                            : "#AD44FF",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "600",
                          fontSize: "10px",
                          lineHeight: "16.2px",
                          color: "#FFFFFF",
                          margin: "0",
                        }}
                      >
                        {" "}
                        {item.priority}
                      </span>
                    </div>)}
                  </div>
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "100px",
                      backgroundColor: "#2A9D4A",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "600",
                        fontSize: "10px",
                        lineHeight: "16.2px",
                        color: "#FFFFFF",
                        margin: "0",
                      }}
                    >
                      {item.user !== undefined && item.user != null && item.user !== "" ? item.user.substring(0, 2).toUpperCase() : ""}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            {isLoadingMore && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "16px 0",
                }}
              >
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    border: "3px solid #E5E5E5",
                    borderTop: "3px solid #6929E2",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite",
                  }}
                />
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
              </div>
            )}
          </div>
        </Col>

        <Col
          sm={12}
          lg={8}
          style={{
            overflowY: "scroll",
            overflowX: "hidden",
            whiteSpace: "nowrap",
            scrollBehavior: "smooth",
            height: "calc(95vh - 130px)",
          }}
        >
          {ticketId !== "" && (
            <div>
              <div
                style={{
                  gap: "24px",
                  padding: "16px",
                  borderRadius: "16px",
                  backgroundColor: "#FFFFFF",
                  marginRight: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      height: "24px",
                      borderRadius: "6px",
                      gap: "10px",
                      paddingLeft: "12px",
                      paddingRight: "12px",
                      backgroundColor: "#EFF3FF",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontSize: "12.5px",
                        fontWeight: "500",
                        lineHeight: "16.88px",
                        color: "#6929E2",
                      }}
                    >
                      {ticketDetail.code}
                    </span>
                    {ticketDetail.ticket_from != null && ticketDetail.ticket_from === "Email" && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            marginLeft: "8px",
                            marginRight: "8px",
                            width: "4px",
                            height: "4px",
                            borderRadius: "100px",
                            background: "#D9D9D9",
                          }}
                        ></div>
                        <div
                          style={{
                            padding: "2px 6px",
                            borderRadius: "6px",
                            backgroundColor: "#e3e9e5",
                            height: "max-content",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "500",
                              fontSize: "12px",
                              color: "#20824A",
                            }}
                          >
                            Mail
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: "8px" }}>
                    {checkAdditionalPermission("Status update") && (ticketDetail.status === "Open" || ticketDetail.status === "Hold" || ticketDetail.status === "Reopen") && (
                      <div
                        onClick={() => {
                          statusUpdate("In Progress");
                        }}
                        style={{
                          cursor: "pointer",
                          height: "36px",
                          borderRadius: "100px",
                          border: "0.6px solid #E5E5E5",
                          padding: "10px 28px 10px 28px",
                          gap: "10px",
                          backgroundColor: "#3253EB",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "18.9px",
                            margin: "0",
                            color: "#FFFFFF",
                          }}
                        >
                          {ticketDetail.status === "Open" ? "Start Progress" : "Resume"}
                        </p>
                      </div>
                    )}
                    {checkAdditionalPermission("Status update") && (ticketDetail.sub_ticket_status === "Closed" || !ticketDetail.sub_ticket_status) && (ticketDetail.status === "In Progress" || ticketDetail.status === "In-Progress") && (
                      <div
                        onClick={() => {
                          /* setIsOpenHold(true); 
                              setIsOpenStatusUpdate(true);
                              setExpectedDate(moment(new Date()).format("YYYY-MM-DD")); */
                          setUpdateStatus("Hold");
                          setShowStatusUpdate(true);
                        }}
                        style={{
                          cursor: "pointer",
                          height: "36px",
                          borderRadius: "100px",
                          border: "0.6px solid #E5E5E5",
                          padding: "10px 28px 10px 28px",
                          gap: "10px",
                          backgroundColor: "#3253EB",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "18.9px",
                            margin: "0",
                            color: "#FFFFFF",
                          }}
                        >
                          Hold
                        </p>
                      </div>
                    )}
                    {checkAdditionalPermission("Status update") && (ticketDetail.sub_ticket_status === "Closed" || !ticketDetail.sub_ticket_status) && (ticketDetail.status === "In Progress" || ticketDetail.status === "In-Progress") && (
                      <div
                        onClick={() => {
                          /* setIsOpenClose(true);
                              setIsOpenStatusUpdate(true);
                              setClosingDate(moment(new Date()).format("YYYY-MM-DD")) */
                          setUpdateStatus("Closed");
                          setShowStatusUpdate(true);
                        }}
                        style={{
                          cursor: "pointer",
                          height: "36px",
                          borderRadius: "100px",
                          border: "0.6px solid #E5E5E5",
                          padding: "10px 28px 10px 28px",
                          gap: "10px",
                          backgroundColor: "#20824A",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "18.9px",
                            margin: "0",
                            color: "#FFFFFF",
                          }}
                        >
                          Close
                        </p>
                      </div>
                    )}
                    {checkAdditionalPermission("Status update") && ticketDetail.status === "Closed" && (
                      <div
                        onClick={() => {
                          /* statusUpdate('Completed') */
                          /* setIsOpenStatusUpdate(true) */
                          setUpdateStatus("Completed");
                          setShowStatusUpdate(true);
                        }}
                        style={{
                          cursor: "pointer",
                          height: "36px",
                          borderRadius: "100px",
                          border: "0.6px solid #E5E5E5",
                          padding: "10px 28px 10px 28px",
                          gap: "10px",
                          backgroundColor: "#20824A",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "18.9px",
                            margin: "0",
                            color: "#FFFFFF",
                          }}
                        >
                          Complete
                        </p>
                      </div>
                    )}
                    {ticketDetail.status === "Completed" && (
                      <div>
                        {[1, 2, 3, 4, 5].map((star) => (
                          <span key={star} style={{ cursor: "pointer", fontSize: "24px" }}>
                            {star <= (ticketDetail.rating ?? 0) ? <img src={yellowIcon} /> : <img src={greyIcon} />}
                          </span>
                        ))}
                      </div>
                    )}
                    {/* <div style={{height:'44px',gap:'10px',borderRadius:'100px',padding:'10px',gap:'10px',backgroundColor:'#FFFFFF',display:'flex',justifyContent:'center',alignItems:'center',marginLeft:'12px',border:'1px solid #E5E5E5'}}>
                        <div style={{width:'24px',height:'24px', display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <img src={set} style={{margin:'0'}}/>
                        </div>  
                    </div> */}
                  </div>
                </div>

                <div style={{ marginTop: "8px" }}>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "16px",
                      lineHeight: "24.3px",
                      color: "#212129",
                    }}
                  >
                    {ticketDetail.title}{" "}
                    {ticketDetail.is_sub === true && (
                      <img
                        src={subTicketIcon}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginLeft: "8px",
                          marginTop: "-5px",
                        }}
                      />
                    )}
                  </span>
                </div>

                <div
                  style={{
                    marginBottom: "8px",
                    paddingBottom: "8px",
                    borderBottom: "1px dashed #E5E5E5",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                    }}
                  >
                    Created on {ticketDetail.created}
                  </span>
                </div>

                <div style={{ marginBottom: "8px" }}>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "18.9px",
                      color: "#212129",
                    }}
                  >
                    Ticket Details
                  </span>
                </div>

                <div style={{ gap: "4px", display: "flex", flex: "10" }}>
                  <p
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                      margin: "0px",
                    }}
                  >
                    {getFieldLabel("Project", "Project")}
                  </p>
                  <p
                    style={{
                      flex: "6",
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "13px",
                      lineHeight: "18.9px",
                      color: "#212129",
                      margin: "0px",
                    }}
                  >
                    {ticketDetail.project}
                  </p>
                </div>
                {ticketDetail.levels !== undefined &&
                  ticketDetail.levels.map((levelOption, index) => (
                    <div
                      style={{
                        gap: "4px",
                        display: "flex",
                        flex: "10",
                        marginTop: "8px",
                      }}
                    >
                      <p
                        style={{
                          flex: "2",
                          fontFamily: "Satoshi",
                          fontWeight: "400",
                          fontSize: "12px",
                          lineHeight: "17.55px",
                          color: "#8790A1",
                        }}
                      >
                        Level{index + 1}
                      </p>
                      <p
                        style={{
                          flex: "6",
                          fontFamily: "Satoshi",
                          fontWeight: "500",
                          fontSize: "13px",
                          lineHeight: "18.9px",
                          color: "#212129",
                        }}
                      >
                        {levelOption.label}
                      </p>
                    </div>
                  ))}
                {/* <div style={{gap:'4px',display:'flex',flex:'10',}}>
                                <p style={{flex:'2',fontFamily:'Satoshi',fontWeight:'400px',fontSize:'13px',lineHeight:'17.55px',color:'#8790A1'}}>Module</p>
                                <p style={{flex:'6',fontFamily:'Satoshi',fontWeight:'500px',fontSize:'14px',lineHeight:'18.9px',color:'#212129'}}>{ticketDetail.module}</p>
                            </div>

                            <div style={{gap:'4px',display:'flex',flex:'10',}}>
                                <p style={{flex:'2',fontFamily:'Satoshi',fontWeight:'400px',fontSize:'13px',lineHeight:'17.55px',color:'#8790A1'}}>Component</p>
                                <p style={{flex:'6',fontFamily:'Satoshi',fontWeight:'500px',fontSize:'14px',lineHeight:'18.9px',color:'#212129'}}>{ticketDetail.component}</p>
                            </div>

                            <div style={{gap:'4px',display:'flex',flex:'10',}}>
                                <p style={{flex:'2',fontFamily:'Satoshi',fontWeight:'400px',fontSize:'13px',lineHeight:'17.55px',color:'#8790A1'}}>Sub component</p>
                                <p style={{flex:'6',fontFamily:'Satoshi',fontWeight:'500px',fontSize:'14px',lineHeight:'18.9px',color:'#212129'}}>{ticketDetail.sub_component}</p>
                            </div> */}

                <div
                  style={{
                    gap: "4px",
                    display: "flex",
                    flex: "10",
                    marginTop: "8px",
                  }}
                >
                  <div
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                    }}
                  >
                    {getFieldLabel("Priority", "Priority")}
                  </div>
                  {ticketDetail.priority != null && ticketDetail.priority != "" && (
                    <div style={{ display: "flex", flex: "6", alignItems: "center" }}>
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "2px",
                          backgroundColor: getPriorityColor(ticketDetail.priority),
                          marginRight: "8px",
                        }}
                      ></span>
                      <div
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "500",
                          fontSize: "13px",
                          lineHeight: "18.9px",
                          color: "#212129",
                        }}
                      >
                        {ticketDetail.priority}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  gap: "16px",
                  backgroundColor: "#FFFFFF",
                  marginTop: "16px",
                }}
              >
                <div style={{ marginBottom: "12px" }}>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "21.6px",
                      color: "#212129",
                    }}
                  >
                    Other Details
                  </span>
                </div>

                <div
                  style={{
                    gap: "4px",
                    display: "flex",
                    flex: "10",
                    marginBottom: "12px",
                  }}
                >
                  <span
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                    }}
                  >
                    {getFieldLabel("Estimation", "Estimation")}
                  </span>
                  <span
                    style={{
                      flex: "6",
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "13px",
                      lineHeight: "18.9px",
                      color: "#212129",
                    }}
                  >
                    {ticketDetail.est ?? "--:--"}hrs
                  </span>
                </div>

                <div
                  style={{
                    gap: "4px",
                    display: "flex",
                    flex: "10",
                    marginBottom: "12px",
                  }}
                >
                  <span
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                      marginTop: "5px",
                    }}
                  >
                    {getFieldLabel("Assign To", "Assigned To")}
                  </span>
                  <div style={{ display: "flex", flex: "6" }}>
                    <img
                      src={ticketDetail.assignee_img != null && ticketDetail.assignee_img !== "" ? ticketDetail.assignee_img : UserImg}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = UserImg;
                      }}
                      style={{
                        width: "24px",
                        height: "24px",
                        marginRight: "8px",
                        borderRadius: "100px",
                      }}
                    />
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "500",
                        fontSize: "13px",
                        lineHeight: "18.9px",
                        color: "#212129",
                        marginTop: "5px",
                      }}
                    >
                      {ticketDetail.assignee}
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    gap: "4px",
                    display: "flex",
                    flex: "10",
                    marginBottom: "12px",
                  }}
                >
                  <span
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                      marginTop: "5px",
                    }}
                  >
                    {getFieldLabel("Reporter", "Reporter")}
                  </span>
                  <div style={{ display: "flex", flex: "6" }}>
                    <img
                      src={ticketDetail.reporter_img != null && ticketDetail.reporter_img !== "" ? ticketDetail.reporter_img : UserImg}
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = UserImg;
                      }}
                      style={{
                        width: "24px",
                        height: "24px",
                        marginRight: "8px",
                        borderRadius: "100px",
                      }}
                    />
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "500",
                        fontSize: "13px",
                        lineHeight: "18.9px",
                        color: "#212129",
                        marginTop: "5px",
                      }}
                    >
                      {ticketDetail.reporter}
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    gap: "4px",
                    display: "flex",
                    flex: "10",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                    }}
                  >
                    Email ID
                  </div>
                  <div
                    style={{
                      flex: "6",
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "13px",
                      lineHeight: "18.9px",
                      color: "#212129",
                    }}
                  >
                    {ticketDetail.reporter_email}
                  </div>
                </div>

                <div
                  style={{
                    gap: "4px",
                    display: "flex",
                    flex: "10",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                    }}
                  >
                    {getFieldLabel("Team", "Team")}
                  </div>
                  <div
                    style={{
                      flex: "6",
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "13px",
                      lineHeight: "18.9px",
                      color: "#212129",
                    }}
                  >
                    {ticketDetail.team}
                  </div>
                </div>

                <div
                  style={{
                    gap: "4px",
                    display: "flex",
                    flex: "10",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                    }}
                  >
                    {getFieldLabel("Create Date", "Created date")}
                  </div>
                  <div
                    style={{
                      flex: "6",
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "13px",
                      lineHeight: "18.9px",
                      color: "#212129",
                    }}
                  >
                    {ticketDetail.created}
                  </div>
                </div>

                <div style={{ gap: "4px", display: "flex", flex: "10" }}>
                  <div
                    style={{
                      flex: "2",
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "12px",
                      lineHeight: "17.55px",
                      color: "#8790A1",
                    }}
                  >
                    {getFieldLabel("Expected Date", "Expected date")}
                  </div>
                  <div
                    style={{
                      flex: "6",
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "13px",
                      lineHeight: "18.9px",
                      color: "#212129",
                    }}
                  >
                    {ticketDetail.expected}
                  </div>
                </div>
              </div>

              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  gap: "16px",
                  backgroundColor: "#FFFFFF",
                  marginTop: "16px",
                }}
              >
                <div style={{ gap: "24px", marginBottom: "12px" }}>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "14px",
                      lineHeight: "21.6px",
                      color: "#212129",
                    }}
                  >
                    {getFieldLabel("Description", "Description")}
                  </span>
                </div>
                <div
                  style={{
                    gap: "24px",
                    paddingBottom: "12px",
                    marginBottom: "12px",
                    borderBottom: "1px dashed #E5E5E5",
                  }}
                >
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "400",
                      fontSize: "15px",
                      lineHeight: "20.25px",
                      color: "#212129",
                      margin: 0,
                    }}
                  >
                    <HtmlContent html={ticketDetail.description || "N/A"} />
                  </p>
                </div>

                {isFieldEnabled("Action Plan") && (
                  <div style={{ marginBottom: "12px", paddingBottom: "12px", borderBottom: "1px dashed #E5E5E5" }}>
                    <div style={{ gap: "24px", marginBottom: "8px" }}>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          lineHeight: "21.6px",
                          color: "#212129",
                        }}
                      >
                        {getFieldLabel("Action Plan", "Action Plan")}
                      </span>
                    </div>
                    <p
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "15px",
                        lineHeight: "20.25px",
                        color: "#212129",
                        margin: 0,
                      }}
                    >
                      <HtmlContent html={ticketDetail.action_plan || "N/A"} />
                    </p>
                  </div>
                )}

                {isFieldEnabled("Action Taken") && ticketDetail.action_taken && (
                  <div style={{ marginBottom: "12px", paddingBottom: "12px", borderBottom: "1px dashed #E5E5E5" }}>
                    <div style={{ gap: "24px", marginBottom: "8px" }}>
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          lineHeight: "21.6px",
                          color: "#212129",
                        }}
                      >
                        {getFieldLabel("Action Taken", "Action Taken")}
                      </span>
                    </div>
                    <p
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "15px",
                        lineHeight: "20.25px",
                        color: "#212129",
                        margin: 0,
                      }}
                    >
                      <HtmlContent html={ticketDetail.action_taken} />
                    </p>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "16px",
                        color: "#212129",
                      }}
                    >
                      {getFieldLabel("Attachment", "Attachment")} : {attachmentList.length}
                    </span>
                  </div>
                  {checkAdditionalPermission("Add attachment") && ticketDetail.status !== "Merged" && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && (
                    <div>
                      <div onClick={handleFileClick}>
                        <span
                          style={{
                            cursor: "pointer",
                            fontFamily: "Satoshi",
                            fontSize: "13px",
                            fontWeight: "700",
                            color: "#6929E2",
                          }}
                        >
                          + {getFieldLabel("Attachment", "Add Attachment")}
                        </span>
                      </div>
                      <input ref={fileInputRef} type="file" accept=".jpg, .jpeg, .png,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/pdf" style={{ display: "none" }} onChange={handleFileChange} />
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "640px",
                    gap: "16px",
                  }}
                >
                  {attachmentList.length > 0 && (
                    <div
                      style={{
                        marginTop: "16px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        gap: "16px",
                      }}
                    >
                      {attachmentList.map((item, attachIndex) => (
                        <div
                          onClick={(e) => {
                            if (e.target.closest('[data-no-preview="true"]')) {
                              return;
                            }
                            openImagePreview(item);
                          }}
                          style={{
                            width: "240px",
                            height: "62px",
                            borderRadius: "12px",
                            padding: "12px 16px 12px 16px",
                            backgroundColor: "#F7F7F7",
                            display: "flex",
                            alignItems: "center",
                            cursor: isImageAttachment(item) ? "pointer" : "default",
                          }}
                        >
                          <img src={getAttachmentIcon(item)} style={{ width: "37px", height: "36px" }} />
                          <div
                            style={{
                              width: "240px",
                              marginLeft: "8px",
                              marginTop: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "500",
                                fontSize: "13px",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "2px",
                              }}
                            >
                              {item.name}
                            </span>
                            <br />
                            <p
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "12px",
                                lineHeight: "16.2px",
                                color: "#8790A1",
                              }}
                            >
                              {item.size}
                            </p>
                          </div>

                          {item.url && (
                            <div
                              data-no-preview="true"
                              onClick={(e) => {
                                e.stopPropagation();
                                downloadFile(item.url, item.name);
                              }}
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "100px",
                              }}
                            >
                              <img
                                src={download}
                                style={{
                                  cursor: "pointer",
                                  width: "12.8px",
                                  height: "12px",
                                  top: "10px",
                                  left: "9.6px",
                                }}
                                alt="Download"
                              />
                            </div>
                          )}

                          <div
                            data-no-preview="true"
                            style={{
                              position: "relative",
                              width: "32px",
                              height: "32px",
                              borderRadius: "100px",
                              marginLeft: "4px",
                            }}
                          >
                            <img
                              data-no-preview="true"
                              src={set}
                              style={{
                                cursor: "pointer",
                                width: "12.8px",
                                height: "12px",
                                top: "10px",
                                left: "9.6px",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setAlertIndex(attachIndex === alertIndex ? null : attachIndex);
                              }}
                            />
                            {alertIndex === attachIndex && (
                              <div
                                data-no-preview="true"
                                ref={alertRef}
                                onClick={(e) => e.stopPropagation()}
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  backgroundColor: "#ffffff",
                                  color: "#1E1E1E",
                                  padding: "16px",
                                  borderRadius: "16px",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                  zIndex: 1,
                                  alignItems: "end",
                                }}
                              >
                                <div
                                  data-no-preview="true"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeAttachment(item.id);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    width: "150px",
                                    height: "36px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#1E1E1E",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                  }}
                                >
                                  Delete
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  gap: "16px",
                  backgroundColor: "#FFFFFF",
                  marginTop: "16px",
                }}
              >
                {/*  <div style={{width:'419px',gap:'24px',marginBottom:'32px'}}>
                        <span style={{fontFamily:'Satoshi',fontWeight:'700px',fontSize:'16px',lineHeight:'21.6px',color:'#212129'}}>Comments</span>
                    </div>

                    <div style={{display:'flex',justifyContent:'center',textAlign:'center'}}>
                        <div style={{height:'114px',width:'265px',gap:'16px',margin:'0'}}>
                            <div style={{display:'flex',justifyContent:'center',textAlign:'center'}}>
                                <img src={note} style={{width:'80px',height:'80px',opacity:'70px',marginBottom:'16px',margin:'0'}} />
                            </div>
                            <p style={{fontFamily:'Satoshi',fontWeight:'500px',fontSize:'13px',lineHeight:'17.55px',color:'#212129'}}>Add your comments by clicking below button</p>
                        </div>
                    </div>

                    <div style={{display:'flex',justifyContent:'center',textAlign:'center',marginBottom:'50x'}}>
                        <div style={{margin:'0',height:'36px',borderRadius:'8px',padding:'10px 16px 10px 16px',gap:'8px',backgroundColor:'#EBEEFF'}}>
                            <p style={{fontFamily:'Satoshi',fontSize:'13px',lineHeight:'17.55px',fontWeight:'700px',color:'#212129'}}>+ Add Comment</p>
                        </div>
                    </div> */}
                {commentsList.length === 0 && (
                  <>
                    <div
                      style={{
                        width: "419px",
                        gap: "24px",
                        marginBottom: "32px",
                      }}
                    >
                      <span
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "16px",
                          lineHeight: "21.6px",
                          color: "#212129",
                        }}
                      >
                        Comments
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          height: "114px",
                          width: "265px",
                          gap: "16px",
                          margin: "0",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          <img
                            src={note}
                            style={{
                              width: "80px",
                              height: "80px",
                              opacity: "70px",
                              marginBottom: "16px",
                              margin: "0",
                            }}
                          />
                        </div>
                        <p
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                          }}
                        >
                          Add your comments by clicking below button
                        </p>
                      </div>
                    </div>
                    {checkAdditionalPermission("Add comment") && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <div
                          onClick={() => {
                            setIsOpenComment(true);
                          }}
                          style={{
                            margin: "0",
                            height: "36px",
                            borderRadius: "8px",
                            padding: "10px 16px 10px 16px",
                            gap: "8px",
                            backgroundColor: "#EBEEFF",
                          }}
                        >
                          <p
                            style={{
                              cursor: "pointer",
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              fontWeight: "700",
                              color: "#212129",
                            }}
                          >
                            + Add Comment
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {commentsList.length > 0 && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "16px",
                            lineHeight: "21.6px",
                            color: "#212129",
                          }}
                        >
                          Comments
                        </span>
                      </div>
                      {checkAdditionalPermission("Add comment") && ticketDetail.status !== "Merged" && ticketDetail.status !== "Closed" && ticketDetail.status !== "Completed" && (
                        <div
                          onClick={() => {
                            setIsOpenComment(true);
                          }}
                        >
                          <p
                            style={{
                              cursor: "pointer",
                              fontFamily: "Satoshi",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              fontWeight: "700",
                              color: "#6929E2",
                            }}
                          >
                            + Add Comment
                          </p>
                        </div>
                      )}
                    </div>
                    {commentsList.map((comment) => (
                      <div
                        style={{
                          paddingTop: "16px",
                          paddingBottom: "16px",
                          borderBottom: "0.5px solid #D4DDE7",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                          }}
                        >
                          <img
                            src={comment.image != null && comment.image !== "" ? comment.image : UserImg}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = UserImg;
                            }}
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "100px",
                            }}
                            alt="comment user"
                          />
                          <span
                            style={{
                              marginLeft: "8px",
                              fontSize: "13px",
                              fontWeight: "700",
                              color: "#212129",
                            }}
                          >
                            {comment.name}
                          </span>
                          {comment.comment_from != null && comment.comment_from === "Email" && (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <div
                                style={{
                                  marginLeft: "8px",
                                  marginRight: "8px",
                                  width: "4px",
                                  height: "4px",
                                  borderRadius: "100px",
                                  background: "#D9D9D9",
                                }}
                              ></div>
                              <div
                                style={{
                                  padding: "2px 6px",
                                  borderRadius: "6px",
                                  backgroundColor: "#e3e9e5",
                                  height: "max-content",
                                }}
                              >
                                <div
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    color: "#20824A",
                                  }}
                                >
                                  Mail
                                </div>
                              </div>
                            </div>
                          )}
                          <div
                            style={{
                              marginLeft: "8px",
                              marginRight: "8px",
                              width: "4px",
                              height: "4px",
                              borderRadius: "100px",
                              background: "#D9D9D9",
                            }}
                          ></div>
                          <span
                            style={{
                              fontSize: "11px",
                              fontWeight: "500",
                              color: "#98A1B0",
                            }}
                          >
                            {comment.date}
                          </span>
                        </div>
                        {/* <span
                          style={{
                            paddingTop: "16px",
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#212129",
                          }}
                        >
                          {comment.comment}
                        </span> */}
                        <HtmlContent html={comment.comment || "N/A"} />
                      </div>
                    ))}
                    {commentsList.length > 0 && totalCommentCount > commentsList.length && (
                      <button
                        style={{
                          height: "44px",
                          color: "#FFFFFF",
                          gap: "8px",
                          backgroundColor: "#FFFFFF",
                          marginLeft: "8px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textDecoration: "none",
                          border: "none",
                        }}
                        onClick={() => getCommentsList("seeMore")}
                      >
                        <p style={{ margin: "0", color: "#6929E2" }}>Load more...</p>
                      </button>
                    )}
                  </>
                )}
                {isOpenComment && (
                  <div style={commentModalStyle.overlay}>
                    <div style={commentModalStyle.modal}>
                      <div style={{ color: "#ffffff" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            <div
                              style={{
                                paddingLeft: "4px",
                                fontSize: "20px",
                                fontWeight: "500",
                                color: "#212129",
                              }}
                            >
                              Add your comments
                            </div>
                            <div
                              style={{
                                paddingLeft: "4px",
                                fontSize: "20px",
                                fontWeight: "400",
                                color: "#98A1B0",
                              }}
                            >
                              {ticketDetail.title ?? ""}
                            </div>
                          </div>

                          <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeCommentModal} />
                        </div>

                        <div style={{ marginTop: "20px" }}>
                          <div>
                            <div>
                              <textarea
                                type="text"
                                placeholder=" "
                                className="form-control"
                                value={descriptionInputValue}
                                rows={6}
                                onChange={(event) => {
                                  setDescriptionInputValue(event.target.value); // Update state with input value
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {validations.description}
                              </span>
                            </div>
                          </div>
                          <Row
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "end",
                              marginTop: "8px",
                            }}
                          >
                            <div
                              onClick={(e) => {
                                closeCommentModal();
                              }}
                              style={{
                                cursor: "pointer",
                                width: "176px",
                                height: "44px",
                                marginLeft: "8px",
                                marginRight: "8px",
                                borderRadius: "100px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#FFFFFF",
                                border: "0.6px solid #E5E5E5",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  color: "#1E1E1E",
                                }}
                              >
                                Cancel
                              </div>
                            </div>
                            <div
                              onClick={(e) => {
                                if (loading === false) {
                                  saveComment();
                                }
                              }}
                              style={{
                                cursor: "pointer",
                                width: "176px",
                                height: "44px",
                                marginLeft: "8px",
                                marginRight: "8px",
                                borderRadius: "100px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#3253EB",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  color: "#FFFFFF",
                                }}
                              >
                                Add
                              </div>
                            </div>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  gap: "16px",
                  backgroundColor: "#FFFFFF",
                  marginTop: "16px",
                }}
              >
                <div>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "16px",
                      lineHeight: "21.6px",
                      color: "#212129",
                      marginBottom: "24px",
                    }}
                  >
                    Workflow History : {workflowList.length}
                  </p>
                </div>
                {workflowList.length > 0 &&
                  workflowList.map((workflow, wIndex) => (
                    <div style={{ display: "flex" }}>
                      <div style={{ paddingTop: "10px", gap: "3px" }}>
                        <div style={{ width: "32px", height: "32px" }}>
                          <div
                            style={{
                              width: "31.33px",
                              height: "31.33px",
                              top: "0.34px",
                              left: "0.34px",
                              borderRadius: "100px",
                              opacity: "40px",
                              backgroundColor: "#ACB9FF",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <img src={getStatusIcon(workflow.status)} style={{ margin: "0" }} alt="status" />
                          </div>
                        </div>
                        {workflowList.length - 1 !== wIndex && (
                          <div
                            style={{
                              height: "64px",
                              borderLeft: "1px dashed #6929E2",
                              marginLeft: "14px",
                            }}
                          ></div>
                        )}
                      </div>

                      <div style={{ gap: "24px", marginLeft: "16px" }}>
                        <div>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#212129",
                            }}
                          >
                            {workflow.status}
                          </span>
                        </div>
                        <div>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            {workflow.description}
                          </span>
                        </div>

                        <div>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "12px",
                              lineHeight: "16.2px",
                              color: "#8790A1",
                            }}
                          >
                            {workflow.date}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </Col>

        {isImagePreviewOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1200,
              padding: "16px",
            }}
            onClick={closeImagePreview}
          >
            <div
              style={{
                position: "relative",
                width: "min(90vw, 1200px)",
                maxHeight: "90vh",
                backgroundColor: "#FFFFFF",
                borderRadius: "12px",
                padding: "12px",
                display: "flex",
                flexDirection: "column",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "8px",
                }}
              >
                <span
                  style={{
                    fontFamily: "Satoshi",
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#212129",
                    maxWidth: "calc(100% - 40px)",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={previewImageName}
                >
                  {previewImageName}
                </span>
                <button
                  type="button"
                  onClick={closeImagePreview}
                  style={{
                    border: "none",
                    background: "transparent",
                    fontSize: "22px",
                    lineHeight: 1,
                    cursor: "pointer",
                    color: "#212129",
                  }}
                >
                  x
                </button>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "auto",
                }}
              >
                <img
                  src={previewImageUrl}
                  alt={previewImageName || "attachment preview"}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "calc(90vh - 80px)",
                    objectFit: "contain",
                  }}
                  onError={closeImagePreview}
                />
              </div>
            </div>
          </div>
        )}

        {isOpenStatusUpdate && (
          <div style={closeModalStyle.overlay}>
            <div style={closeModalStyle.modal}>
              <div style={{ color: "#ffffff" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                    }}
                  >
                    <div
                      style={{
                        paddingLeft: "4px",
                        fontSize: "20px",
                        fontWeight: "500",
                        color: "#212129",
                      }}
                    >
                      {isOpenHold === true ? "Holding remarks" : ""} {isOpenClose === true ? "Closing remarks" : ""} {isOpenHold === false && isOpenClose === false ? "Completing remarks" : ""}
                    </div>
                    <div
                      style={{
                        paddingLeft: "4px",
                        fontSize: "20px",
                        fontWeight: "400",
                        color: "#98A1B0",
                      }}
                    >
                      {ticketDetail.title ?? ""}
                    </div>
                  </div>

                  <ModalCloseIcon style={{ cursor: "pointer" }} onClick={closeStatusUpdateModal} />
                </div>

                <div style={{ marginTop: "8px" }}>
                  {isOpenHold === true && (
                    <div>
                      <div
                        style={{
                          paddingTop: "6px",
                          paddingBottom: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                        }}
                      >
                        Expected Date
                      </div>
                      <div style={{ position: "relative", height: "40px" }}>
                        {/* Input with Icon */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "0.7px solid #E5E5E5",
                            borderRadius: "8px",
                            padding: "6px 12px",
                          }}
                        >
                          <input
                            type="text"
                            value={expectedDate !== null && expectedDate !== "" ? formatDate(expectedDate) : ""}
                            onClick={() => setShowPicker(!showPicker)}
                            readOnly
                            style={{
                              flex: 1,
                              border: "none",
                              outline: "none",
                              cursor: "pointer",
                            }}
                            placeholder="Select a date"
                          />
                          <CalendarIcon style={{ cursor: "pointer", color: "#842234" }} onClick={() => setShowPicker(!showPicker)} />
                        </div>

                        {/* Day Picker */}
                        {showPicker && (
                          <div
                            ref={alertDatePicRef}
                            style={{
                              position: "absolute",
                              top: "50px" /* Moves the picker above the button */,
                              left: 0,
                              zIndex: 100,
                              background: "white",
                              border: "1px solid #ddd",
                              padding: "10px",
                              borderRadius: "5px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                              color: "#21272C",
                            }}
                          >
                            <DayPicker mode="single" selected={expectedDate} onSelect={handleDateChange} hidden={{ after: new Date() }} />
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.expected_date}
                      </div>
                    </div>
                  )}
                  {isOpenClose === true && (
                    <Row>
                      <Col sm={6}>
                        <div
                          style={{
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "13px",
                            fontWeight: "500",
                            color: "#212129",
                          }}
                        >
                          Work Duration
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          value={workDuration}
                          onChange={handleChange}
                          onKeyDown={(event) => {
                            setLastKey(event.key);
                          }}
                          placeholder="HH:MM"
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.work_duration}
                        </span>
                      </Col>
                      <Col sm={6}>
                        <div
                          style={{
                            paddingTop: "6px",
                            paddingBottom: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "13px",
                            fontWeight: "500",
                            color: "#212129",
                          }}
                        >
                          Closing Date
                        </div>
                        <div style={{ position: "relative", height: "40px" }}>
                          {/* Input with Icon */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              border: "0.7px solid #E5E5E5",
                              borderRadius: "8px",
                              padding: "6px 12px",
                            }}
                          >
                            <input
                              type="text"
                              value={closingDate !== null && closingDate !== "" ? formatDate(closingDate) : ""}
                              onClick={() => setShowPicker(!showPicker)}
                              readOnly
                              style={{
                                flex: 1,
                                border: "none",
                                outline: "none",
                                cursor: "pointer",
                              }}
                              placeholder="Select a date"
                            />
                            <CalendarIcon style={{ cursor: "pointer", color: "#842234" }} onClick={() => setShowPicker(!showPicker)} />
                          </div>
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.closing_date}
                          </span>
                          {/* Day Picker */}
                          {showPicker && (
                            <div
                              ref={alertDatePicRef}
                              style={{
                                position: "absolute",
                                top: "50px" /* Moves the picker above the button */,
                                right: 0,
                                zIndex: 100,
                                background: "white",
                                border: "1px solid #ddd",
                                padding: "10px",
                                borderRadius: "5px",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                color: "#21272C",
                              }}
                            >
                              <DayPicker mode="single" selected={closingDate} onSelect={handleClosingDateChange} hidden={{ after: new Date() }} />
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  )}
                  {ticketDetail.status === "Closed" && (
                    <div>
                      <div
                        style={{
                          paddingTop: "6px",
                          paddingBottom: "6x",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                        }}
                      >
                        Rating
                      </div>
                      <div style={{ display: "flex", justifyContent: "start" }}>
                        {[1, 2, 3, 4, 5].map((star) => (
                          <span key={star} onClick={() => setRating(star)} style={{ cursor: "pointer", fontSize: "24px" }}>
                            {star <= rating ? <img src={yellowIcon} /> : <img src={greyIcon} />}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                  <div>
                    <div>
                      <div
                        style={{
                          paddingTop: "6px",
                          paddingBottom: "6x",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                        }}
                      >
                        Description
                      </div>
                      <textarea
                        type="text"
                        placeholder=" "
                        className="form-control"
                        value={descriptionInputValue}
                        rows={6}
                        onChange={(event) => {
                          setDescriptionInputValue(event.target.value); // Update state with input value
                        }}
                      />
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.description}
                      </span>
                    </div>
                  </div>
                  <Row
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                      marginTop: "16px",
                    }}
                  >
                    <div
                      onClick={(e) => {
                        closeStatusUpdateModal();
                      }}
                      style={{
                        cursor: "pointer",
                        width: "176px",
                        height: "44px",
                        marginLeft: "8px",
                        marginRight: "8px",
                        borderRadius: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0.6px solid #E5E5E5",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#1E1E1E",
                        }}
                      >
                        Cancel
                      </div>
                    </div>
                    <div
                      onClick={(e) => {
                        if (loading === false) {
                          if (isOpenHold) {
                            statusUpdate("Hold");
                          }
                          if (isOpenClose) {
                            statusUpdate("Closed");
                          }
                          if (!isOpenHold && !isOpenClose) {
                            statusUpdate("Completed");
                          }
                        }
                      }}
                      style={{
                        cursor: "pointer",
                        width: "176px",
                        height: "44px",
                        marginLeft: "8px",
                        marginRight: "8px",
                        borderRadius: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#3253EB",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#FFFFFF",
                        }}
                      >
                        Submit
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}
      </Row>
    </>
  );
};

export default Ticketlistview;
